import storeModule from '../store-module'
import { defineStore } from 'pinia'

export default defineStore('generics', storeModule.createStoreModule('generics'))
